import React, { Component } from 'react';
import axios from 'axios';
import { Button, Row, Col } from 'react-bootstrap';

import DocumentField from './DocumentField';


class RequiredDocForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            file: null,
            updating: false,
            errors: [],
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateFile = this.validateFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };
        axios.get(`${ROOT_URL}/leads/documents/${this.props.documentType}`, config)
        .then((response)=> {
            this.setState({
                isLoaded: true
            });
            this.props.onUpdateStatus(this.props.documentType)
        });
    }

    validateFile(){
        let errors = [];
        if(!this.props.fileTypes.includes(this.state.file.type)){
            errors.push('Formato de archivo no válido.');
        }
        if(this.state.file.size > this.props.maxSize){
            errors.push('El tamaño del archivo supera el valor permitido.');
        }
        if(errors.length > 0){
            this.setState({...this.state, errors: errors});
            return false;
        }
        return true;
    }

    handleSubmit(event){
        event.preventDefault();
        if(!this.validateFile()){
            return
        }
        this.setState({...this.state, updating: true});
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
                    'Content-Type': 'multipart/form-data'
                }
        };
        const formData = new FormData()
        formData.append('file', this.state.file);
        axios.post(`${ROOT_URL}/leads/documents/${this.props.documentType}`, formData, config)
        .then((response)=> {
            this.setState({
                isLoaded: true
            });
            this.props.onUpdateStatus(this.props.documentType)
        });
    }

    handleChange(file){
        this.setState({
            ...this.state,
            file: file,
            errors:[],
        })
    }

    render() {
        const { updating, file, isLoaded, errors } = {...this.state}
        const field = <DocumentField label={this.props.label} onChange={this.handleChange} updating={updating}/>


         const errorComponent = errors.map(error => {
             return (<Row className="terms_row">
                        <Col className="col-lg-offset-7 col-md-offset-7 col-xs-offset-7" xs={5} md={5} lg={5}>
                            <div className="help-block" style={{color:'#c00'}}>{error}</div>
                        </Col>
                     </Row>);
         });
        const documentForm = (
            <div style={{padding: '10px 0px 10px 0px'}}>
            <Row className="terms_row">
                <Col className="terms_col terms_checkbox pd-vcenter" xs={12} md={10} lg={10}>
                    {field}
                </Col>
                <Col className="terms_col pd-vcenter text-center" xs={12} md={2} lg={2}>
                    <button className={'btn btn-default'} disabled={(updating || !file)} onClick={this.handleSubmit}><span>{updating ? 'Enviando' : 'Enviar'}</span></button>
                </Col>
            </Row>
            {errors ? errorComponent : ''}
            </div>);

        const loadedComponent = (
            <div style={{padding: '10px 0px 10px 0px'}}>
            <Row className="terms_row">
                <Col className="terms_col terms_checkbox pd-vcenter" xs={12} md={10} lg={10}>
                <Row className="terms_row">
                    <Col className="terms_col terms_checkbox pd-vcenter text-center" xs={12} md={12} lg={12}>
                        <span>{this.props.label}</span>
                    </Col>
                </Row>
                </Col>
                <Col className="terms_col pd-vcenter text-center" xs={12} md={2} lg={2}>
                    <button className={'btn btn-success'} disabled={true}><span>Enviado</span></button>
                </Col>
            </Row>
            {errors ? errorComponent : ''}
            </div>);

        const component = isLoaded ? loadedComponent : documentForm

        return component;
    }
}


export default RequiredDocForm;


/** WEBPACK FOOTER **
 ** ./src/components/RequiredDocForm.js
 **/